import StatusPill from 'components/StatusPill';
import { BeneficiaryStatus } from 'containers/Beneficiaries/types';
import { useBeneficiaries } from 'contexts/Beneficiaries';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { capitalize } from 'utils/capitalize';
import { formatDate } from 'utils/formatDate';
import { cpfMask } from 'utils/maskCpf';

const TableRow = () => {
  const { beneficiaries, setCpf } = useBeneficiaries();

  const navigate = useNavigate();

  const isBeneficiaryActive = (beneficiary: BeneficiaryStatus) => beneficiary.status === 'Active';

  return (
    <>
      {beneficiaries?.map((beneficiary, index) => (
        <tr
          className={
            isBeneficiaryActive(beneficiary) ? 'table-beneficiaries-rows' : 'table-beneficiaries-rows inactive'
          }
          key={beneficiary.cpf}
          data-testid={`table-row-${index}`}
          onClick={() => {
            setCpf(beneficiary.cpf);
            navigate(`?p=extrato-beneficiario&cpf=${beneficiary.cpf}`);
          }}
        >
          <td>{formatDate(beneficiary.created)}</td>
          <td>
            <span className="table-span">{capitalize(beneficiary.name)}</span>
          </td>
          <td>{cpfMask(beneficiary.cpf)}</td>
          <td>{formatDate(beneficiary.birthdate)}</td>
          <td>
            <span className="table-span">{beneficiary.email}</span>
          </td>
          <td>
            <StatusPill status={beneficiary.status} />
          </td>

          <td>
            <Link to={`?p=extrato-beneficiario&cpf=${beneficiary.cpf}`} className="chevron" />
          </td>
        </tr>
      ))}
    </>
  );
};

export default TableRow;
